module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Ice-cream1-96878040ec438900055f8837363fd6fc.svg";